/// <reference types="./@types/fdr-hero.theme" />
export { FdrHero } from './fdr-hero';
export { FdrHeroSkeleton } from './fdr-hero.skeleton';
